import React, { useState } from "react";
// import ModalDetails from "../../Modals/ModalDetails";
// import openAccessLogo from "../../../assets/655px-Open_Access_logo.png";
import "./TableDetails.scss";
// import { title, toTitleCase } from "../../Filter/Filter";
// import ReactGA from "react-ga4";
// import SanitizeHtml from "../../SanitizeHtml/SanitizeHtml";
import SanitizeHtml from "../SanitizeHtml/SanitizeHtml";
import orcid from "../assets/orcidIcon.png";
import AuthorModal from "../authorModal/AuthorModal";
import TableCellRender from "./TableCellRender";

const AUTHOR_DEMO_DATA = {
  title: "Machine Learning in Climate Research",
  doi: "10.1016/j.envsoft.2023.105678",
  journal: "Environmental Modelling & Software",
  authors: ["John Doe", "Jane Smith", "Robert Brown", "Emily Davis"],
};

const TableItem = ({
  rowData,
  headerDetails,
  dataKey,
  headers,
  onRowClick,
  customClassName,
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [showFullList, setShowFullList] = useState(false);

  // const authorities = JSON.parse(
  //   sessionStorage.getItem("rat_auth_details")
  // ).authorities;

  // const authority = authorities?.filter(
  //   (item) => item?.authority === "KARGER_2025"
  // );
  const handleClick = (data, field) => {
    onRowClick(data, field);
  };

  const handleClose = () => {
    // setShowManuscriptDetails(false);
  };

  const handleShowMore = (rowData) => {
    if (rowData.authorsList.length > 20) {
      setPopupData(rowData);
      setShowPopup(true);
    } else {
      setShowFullList(true);
    }
  };

  const handleShowLess = () => {
    setShowFullList(false);
  };

  const handleOpenModal = () => {};

  return (
    <>
      {rowData[headerDetails.field] !== null ? (
        <td
          key={dataKey}
          className={`text-start ps-3 py-3 ${
            dataKey === 0 ? "" : customClassName || ""
          }`}
        >
          <TableCellRender
            rowData={rowData}
            headerDetails={headerDetails}
            showFullList={showFullList}
            handleOpenModal={handleOpenModal}
            handleShowMore={handleShowMore}
            handleShowLess={handleShowLess}
            handleClick={handleClick}
          />
        </td>
      ) : (
        // <td
        //   key={dataKey}
        //   className={`text-start ps-5 py-3 ${
        //     dataKey === 0 ? "" : customClassName || ""
        //   }`}
        // >
        //   {headerDetails?.dataType === "url" &&
        //   headerDetails.field === "doi" ? (
        //     <>
        //       <a
        //         href={rowData[headerDetails.field]}
        //         target="_blank"
        //         className={
        //           rowData[headerDetails.field]
        //             ? "linkText"
        //             : "text-secondary" + " flex-box"
        //         }
        //       >
        //         <span className="text-break text-break-sm">
        //           <span>{rowData[headerDetails.field]}</span>
        //         </span>
        //       </a>{" "}
        //     </>
        //   ) : headerDetails.field === "authors" ? (
        //     <div className="flex-box">
        //       <span onClick={handleOpenModal} className="">
        //         {rowData.authorsList.map((author, index) => {
        //           const totalAuthorCount = rowData.authorsList.length;
        //           return index <
        //             (showFullList
        //               ? rowData.authorsList.length < 20
        //                 ? rowData.authorsList.length
        //                 : 3
        //               : 3) ? (
        //             <span key={index}>
        //               {author.orcid && (
        //                 <a
        //                   href={author.orcid}
        //                   target="_blank"
        //                   className="cursor-pointer"
        //                 >
        //                   <img
        //                     height="15px"
        //                     className="me-1 my-1 text-muted"
        //                     src={orcid}
        //                     alt="Author id logo"
        //                   />
        //                 </a>
        //               )}
        //               {author.name}
        //               {index !== totalAuthorCount - 1 ? ", " : ""}
        //               {showFullList && index === totalAuthorCount - 1 && (
        //                 <span
        //                   className="text-secondary cursor-pointer"
        //                   key={index}
        //                   onClick={() => handleShowLess(rowData)}
        //                 >
        //                   {" "}
        //                   {`Show Less`}
        //                 </span>
        //               )}
        //             </span>
        //           ) : (
        //             !showFullList && index === totalAuthorCount - 1 && (
        //               <span
        //                 className="text-secondary cursor-pointer"
        //                 key={index}
        //                 onClick={() => handleShowMore(rowData)}
        //               >
        //                 {" "}
        //                 {`+ ${totalAuthorCount - 3} more`}
        //               </span>
        //             )
        //           );
        //         })}
        //       </span>
        //     </div>
        //   ) : headerDetails.dataType === "url" ? (
        //     <a
        //       target="_blank"
        //       href={rowData[headerDetails.field]}
        //       className="linkText"
        //     >
        //       <span className="text-break text-break-sm">
        //         <span>{rowData[headerDetails.field]}</span>
        //       </span>
        //       {/* {rowData[headerDetails.field]} */}
        //     </a>
        //   ) : (
        //     <span
        //       className={` ${headerDetails?.clickable ? "cursor-pointer" : ""}`}
        //       onClick={() =>
        //         headerDetails?.clickable &&
        //         handleClick(rowData, headerDetails.field)
        //       }
        //     >
        //       {(
        //         <SanitizeHtml
        //           filterText={
        //             headerDetails?.dataType === "percentage"
        //               ? rowData[headerDetails.field] + "%"
        //               : rowData[headerDetails.field]?.toLocaleString("en-US")
        //           }
        //         />
        //       ) || ""}
        //     </span>
        //   )}
        // </td>
        <td className="text-start ps-5 py-3"></td>
      )}

      {showPopup && (
        <AuthorModal
          show={showPopup}
          onHide={() => setShowPopup(false)}
          data={popupData}
        />
      )}
    </>
  );
};

export default TableItem;
